<template>
  <div class="bg-white rounded-lg p-2 shadow-xl overflow-y-auto">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'panel'
}
</script>